export default __webpack_public_path__ + "static/media/Messages.52430f6e.svg";